import { Link } from 'react-router-dom';
import { useBrand } from '../lib/brand';
import { MarketingShell, usePageMeta } from '../marketing/chrome';

export default function Terms() {
  const brand = useBrand();
  usePageMeta(`Terms · ${brand.name}`, `Terms for using ${brand.name}.`);

  return (
    <MarketingShell>
      <article className="mx-auto max-w-copy px-6 py-mkt-sm md:py-mkt">
        <h1 className="text-mkt-section-sm md:text-mkt-section">Terms of Service</h1>
        <p className="mt-3 text-mkt-body text-mkt-secondary">Last updated: 26 May 2026</p>

        <div className="mt-10 space-y-8 text-mkt-body">
          <p>
            These terms govern access to and use of {brand.name}. If you use the service on behalf of a club,
            you confirm you have authority to do so.
          </p>

          <section>
            <h2 className="text-[28px] font-semibold tracking-tight">Use of the service</h2>
            <ul className="mt-3 list-disc space-y-2 pl-5 text-mkt-secondary">
              <li>Use the product lawfully and in line with your club policies</li>
              <li>Keep account access secure and do not share login links</li>
              <li>Only upload information you have the right to share with your club</li>
            </ul>
          </section>

          <section>
            <h2 className="text-[28px] font-semibold tracking-tight">Club data</h2>
            <p className="mt-3 text-mkt-secondary">
              Your club owns its data. We provide tools to export data and we will not lock you in. We may process
              data to deliver the features you enable.
            </p>
          </section>

          <section>
            <h2 className="text-[28px] font-semibold tracking-tight">Availability</h2>
            <p className="mt-3 text-mkt-secondary">
              We aim for high availability, but we do not guarantee uninterrupted service. Planned maintenance
              may occur.
            </p>
          </section>

          <section>
            <h2 className="text-[28px] font-semibold tracking-tight">Changes</h2>
            <p className="mt-3 text-mkt-secondary">
              We may update these terms from time to time. Continued use after changes means you accept the
              updated terms.
            </p>
          </section>

          <section>
            <h2 className="text-[28px] font-semibold tracking-tight">Contact</h2>
            <p className="mt-3 text-mkt-secondary">
              Use the <Link to="/contact" className="text-mkt-accent">contact form</Link>. You can also email{' '}
              <a className="text-mkt-accent" href={`mailto:${brand.email.support}`}>
                {brand.email.support}
              </a>
              .
            </p>
          </section>
        </div>
      </article>
    </MarketingShell>
  );
}
